module.exports = __webpack_public_path__ + "static/icon-charts-07ca254f3e8727afcae35dee15e5783d.svg";